import React from 'react';
import styles from './Certificates.module.css';

const Certificates = ({ items }) => (
  <div className={styles.container}>
    {items.map((cert, i) => (
      <a
        key={i}
        href={cert.pdf}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.tile}
      >
        <img
          src={cert.logo}
          alt={`Sertifika ${i + 1}`}
          loading="lazy"
          onError={e => { e.target.src = '/images/fallback-logo.png'; }}
        />
      </a>
    ))}
  </div>
);

export default React.memo(Certificates);
